var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import moment from "moment";
import { useCallback } from "react";
import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { ActionTypes } from "../../../OrderFlowProvider/OrderFlowActionTypes";
import { ModuleNames, } from "../../../OrderFlowProvider/OrderFlowTypes";
// FIXME: Date types are not set because of the update to MUI 5.
export const shouldDisableDate = (deliveryScheduleMealDays, daysOfWeek, modelDeliveryDays, configDeliveryDaysOnly) => (date) => {
    date = moment(date);
    if (date.isAfter(moment().add(2, "months"))) {
        return true;
    }
    const mealDaysForDate = modelDeliveryDays
        .filter((dd) => moment(dd.ShipDateString).isSame(date, "date"))
        .map((dd) => moment(dd.MealDate).day());
    if (!daysOfWeek.includes(moment(date).day()) && !daysOfWeek.some((day) => mealDaysForDate.includes(day))) {
        return true;
    }
    if (!modelDeliveryDays || !modelDeliveryDays.some((dd) => moment(dd.MealDateString).isSame(date, "date"))) {
        return true;
    }
    const mealDaysForDeliverySchedule = deliveryScheduleMealDays.filter((d) => mealDaysForDate.some((md) => md == d));
    if (mealDaysForDeliverySchedule.length < 1) {
        return true;
    }
    if (configDeliveryDaysOnly && !modelDeliveryDays.some((dd) => moment(dd.ShipDateString).isSame(date, "date"))) {
        return true;
    }
    return false;
};
const disableDateCallback = (deliveryScheduleMealDays, daysOfWeek, modelDeliveryDays, configDeliveryDaysOnly) => useCallback((date) => {
    return shouldDisableDate(deliveryScheduleMealDays, daysOfWeek, modelDeliveryDays, configDeliveryDaysOnly)(date);
}, [daysOfWeek, modelDeliveryDays]);
const handleStartDateChange = (dispatch) => (startDate) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({
        type: ActionTypes.SET_START_DATE,
        payload: moment(startDate),
    });
    dispatch({ type: ActionTypes.SET_RECIPE_FETCH_STATUS, payload: { completed: false, error: false } });
});
/**
 * Checks if the order start date results in a short week.
 *
 * A short week is determined by comparing the start date with the days of the week and the day quantity.
 * If the start date's day of the week does not match the first day of the week, and the number
 * of days after the start date is less than the required quantity, it is considered a short week.
 *
 * @param {string | moment.Moment | null} startDate - The start date of the order
 * @param {number} firstDayOfWeek - The first day of the week
 * @returns {boolean} - Returns true if the start date results in a short week, otherwise false.
 */
export const checkIfOrderContainsShortWeek = (startDate, daysOfWeek, dayQuantity) => {
    const isStartDayFirstDay = daysOfWeek[0] === moment(startDate).day();
    const daysAfterStartDay = daysOfWeek.filter((day) => day >= moment(startDate).day()).length;
    return !isStartDayFirstDay && daysAfterStartDay < (dayQuantity !== null && dayQuantity !== void 0 ? dayQuantity : 0);
};
/**
 * useStartDate - Handles setting the start date change and disabling dates in the datepicker
 * @returns should disable date function based on date and moduleConfig and start date change handler function
 */
export const useStartDate = (sequenceNumber) => {
    var _a, _b, _c;
    const { store, dispatch } = useOrderFlow();
    const moduleConfig = (_a = store.model.Flow.FlowModules.find((module) => module.ModuleName === ModuleNames.START_DATE &&
        module.Sequence === sequenceNumber &&
        module.Page === store.cart.currentPage)) === null || _a === void 0 ? void 0 : _a.ModuleConfig;
    return {
        daysOfWeek: store.cart.daysOfWeek,
        startDate: store.cart.startDate,
        variant: (_b = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.Variant) !== null && _b !== void 0 ? _b : "static",
        disableDateCallback: disableDateCallback(store.model.DeliveryScheduleMealDays, store.cart.daysOfWeek, store.model.DeliveryDays, (_c = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.DeliveryDaysOnly) !== null && _c !== void 0 ? _c : false),
        handleStartDateChange: handleStartDateChange(dispatch),
    };
};
